import Query from '../utils/Query';

export default class TransactionService {

	static run(transactions = []) {
		return Query.post('/custom/transaction/run', transactions);
	}
}
